import React from "react";
import Loader from "../loader/default";

export default function Button(
  {
    href = null,
    className = "",
    disabled = false,
    loading = false,
    attributes = {},
    testRefs = {},
    children = null,
    onClick = null,
    form,
    ref
  }
) {
  if (href) {
    return withHref(
      ref,
      href,
      className,
      disabled,
      loading,
      attributes,
      children,
      onClick,
      testRefs
    );
  }
  return withoutHref(
    ref,
    className,
    disabled,
    loading,
    attributes,
    children,
    onClick,
    testRefs,
    form
  );
};

function withHref(
  ref,
  href,
  className,
  disabled,
  loading,
  attributes,
  children,
  onClick,
  testRefs
) {
  return (
    <a
      ref={ref}
      className={
        className +
        (disabled ? " is-disabled" : "") +
        (loading ? " is-loading" : "")
      }
      {...testRefs}
      href={href}
      {...attributes}
      onClick={onClick}
    >
      {loading ? <Loader className="button__loader" /> : children}
    </a>
  );
}

function withoutHref(
  ref,
  className,
  disabled,
  loading,
  attributes,
  children,
  onClick,
  testRefs,
  form
) {
  return (
    <button
      ref={ref}
      className={
        className +
        (disabled ? " is-disabled" : "") +
        (loading ? " is-loading" : "")
      }
      disabled={disabled || loading}
      onClick={onClick}
      {...attributes}
      {...testRefs}
      form={form}
    >
      {loading ? <Loader className="button__loader" /> : children}
    </button>
  );
}
